import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export const FooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
`;

export const CancelButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.dark1};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OKButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.blackGradient};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.golden};
  border-radius: 0 0 8px 0;
`;

export const Modal = styled(AntModal)`
  .ant-modal-content {
    margin: 0;
    padding: 10px 0 0 0;
  }
`;

export const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
`;

const ConfirmModal = ({ open, loading, onConfirm, handleClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      open={open}
      width={350}
      confirmLoading={loading}
      footer={
        <FooterContainer>
          <CancelButton onClick={handleClose}>
            {t("common.cancel")}
          </CancelButton>
          <OKButton onClick={onConfirm}>{t("common.confirm")}</OKButton>
        </FooterContainer>
      }
    >
      <div style={{ textAlign: "center" }}>
        <ModalTitle>{t("common.confirm")}</ModalTitle>
        <ModalText>{t("wallet.fillAmountConfirmModalLabel")}</ModalText>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
